import { ConfigConstants } from '../../config/config-constants';
import { ODataObject } from '../../interfaces/odata-model.interface';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { CompositeModel } from '../complex/composite.model';
import { BooleanModel, JsonBooleanModel } from '../primitive/boolean.model';
import { JsonNumberModel, NumberModel } from '../primitive/number.model';
import { JsonTextModel, TextModel } from '../primitive/text.model';

export class CseMaterialModel extends CompositeModel {
    public material: TextModel;
    public quantity: NumberModel;
    public description: TextModel;
    public process: ConfigConstants.PROCESS_INDICATOR;
    public isSelected: BooleanModel;
    public isEditable: boolean;
    public isDeletable: boolean;
    public isHidden: boolean;
    public constructor(
        material: string,
        quantity: number | undefined,
        description = '',
        process: ConfigConstants.PROCESS_INDICATOR,
        isSelected = true,
        isDeletable = true,
        isHidden = false,
    ) {
        super('CseMaterialModel', {});
        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        this.material = <TextModel>this.set(new TextModel('Material', material));
        modelOptionsLoader.load(this.material, 'MaterialQuote', 'MaterialNumber', process);

        this.material.options = {
            ...this.material.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
        };

        this.quantity = <NumberModel>this.set(new NumberModel('Quantity', quantity));
        modelOptionsLoader.load(this.quantity, 'MaterialQuote', 'Quantity');
        this.description = <TextModel>this.set(new TextModel('Description', description));
        this.isSelected = new BooleanModel('IsSelected', isSelected);
        this.isDeletable = isDeletable;
        this.isHidden = isHidden;
    }

    /**
     * Creates an empty model for delete recipient action
     */
    public emptyModel(): void {
        this.isHidden = false;
        this.material.value = '';
        this.quantity.value = 0;
        this.description.value = '';
    }

    /**
     * Convert the internal data into an object suitable for OData exchange with SAP
     *
     * @returns updated outmodel
     */
    public getOutModel(): ODataCseMaterialOutModel {
        const outModel = <ODataCseMaterialOutModel>super.getOutModel();
        outModel.Quantity = outModel.Quantity.toString();
        return outModel;
    }
}

export class CseMaterialModelFromJson extends CseMaterialModel {
    public constructor(data: JsonCseMaterialModel) {
        super(
            data.material.value,
            data.quantity.value,
            data.description.value,
            data.process,
            data.isSelected.value,
            data.isDeletable,
            data.isHidden,
        );
    }
}

export interface JsonCseMaterialModel {
    material: JsonTextModel;
    quantity: JsonNumberModel;
    description: JsonTextModel;
    process: ConfigConstants.PROCESS_INDICATOR;
    isSelected: JsonBooleanModel;
    isEditable: boolean;
    isDeletable: boolean;
    isHidden: boolean;
}

export interface ODataCseMaterialOutModel extends ODataObject {
    Material: string;
    Quantity: string;
    Description: string;
    IsSelected: string;
}
